export enum EBootstrapIcons {
  SEND = 'bi bi-send',
  X = 'bi bi-x'
}
